/* Rosterpress free-design uploader, shared by the form (A), $0 product (B) and AI wizard (C) pages.
   Files are stored by Shopify the moment they are added to the cart as line item properties, so the contact-form
   variants use the $0 product as a carrier: POST /cart/add.js (multipart), read the permanent CDN URLs from the
   returned line, then remove the line again (the files stay). Pure helpers are shared with node tests. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.RPDesignUpload = api;
    if (root.document) api.autoInit(root.document);
  }
})(typeof self !== 'undefined' ? self : this, function () {
  var MAX_FILES = 5;
  var MAX_BYTES = 20 * 1024 * 1024;
  var EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'heic', 'heif', 'gif', 'tif', 'tiff', 'svg', 'pdf', 'ai', 'eps', 'psd'];
  var CDN = 'https://cdn.shopify.com/';
  var FAIL_MSG = "We couldn't upload your files. You can send your request now and reply to our email with the files.";

  function extOf(name) { var m = /\.([^.]+)$/.exec(String(name == null ? '' : name)); return m ? m[1].toLowerCase() : ''; }

  function checkFiles(list, max) {
    list = list || [];
    max = max > 0 ? max : MAX_FILES;
    var errors = [];
    if (list.length > max) errors.push('Please add up to ' + max + (max === 1 ? ' file.' : ' files.'));
    list.forEach(function (f) {
      if (!f) return;
      if (EXTENSIONS.indexOf(extOf(f.name)) === -1) errors.push(f.name + ' is not a supported file type. Use a photo, PNG, SVG, PDF, AI, EPS or PSD.');
      else if (f.size > MAX_BYTES) errors.push(f.name + ' is over 20 MB.');
    });
    return { ok: errors.length === 0, errors: errors };
  }

  function sameFile(a, b) { return a.name === b.name && a.size === b.size; }

  /* Adds the incoming files that pass; one bad file never throws away the good ones picked with it. */
  function mergeFiles(existing, incoming, max) {
    max = max > 0 ? max : MAX_FILES;
    var files = (existing || []).slice();
    var errors = [];
    var rejected = [];
    var full = false;
    Array.prototype.forEach.call(incoming || [], function (f) {
      if (!f || files.some(function (g) { return sameFile(f, g); })) return;
      var r = checkFiles([f], 1);
      if (!r.ok) { errors = errors.concat(r.errors); rejected.push(f.name); return; }
      if (files.length >= max) { full = true; rejected.push(f.name); return; }
      files.push(f);
    });
    if (full) errors.push('This box holds up to ' + max + (max === 1 ? ' file.' : ' files.'));
    return { files: files, errors: errors, rejected: rejected };
  }

  var PREFIX_ORDER = ['Logo', 'Artwork', 'Reference', 'File'];

  /* Labelled CDN entries from a cart line: [{label: 'Logo 1', url}], ordered Logo, Artwork, Reference, then legacy File. */
  function urlsFromLine(line) {
    var props = (line && line.properties) || {};
    var found = [];
    Object.keys(props).forEach(function (k) {
      var m = /^(Logo|Artwork|Reference|File) (\d+)$/.exec(k);
      var v = props[k];
      if (m && typeof v === 'string' && v.indexOf(CDN) === 0) found.push({ rank: PREFIX_ORDER.indexOf(m[1]), n: parseInt(m[2], 10), label: k, url: v });
    });
    found.sort(function (a, b) { return a.rank - b.rank || a.n - b.n; });
    return found.map(function (x) { return { label: x.label, url: x.url }; });
  }

  function lineFor(entry) { return entry.label + ': ' + entry.url; }

  function appendFiles(formData, files, prefix) {
    prefix = prefix || 'File';
    (files || []).forEach(function (f, i) { formData.append('properties[' + prefix + ' ' + (i + 1) + ']', f, f.name); });
    return formData;
  }

  /* groups = [{prefix, files}]. One /cart/add.js for every group together; returns [{label, url}]. */
  function uploadViaCart(variantId, groups) {
    groups = (groups || []).filter(function (g) { return g && g.files && g.files.length; });
    if (!groups.length) return Promise.resolve([]);
    var fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    fd.append('properties[_carrier]', '1');
    groups.forEach(function (g) { appendFiles(fd, g.files, g.prefix); });
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (line) {
        var urls = urlsFromLine(line);
        var done = function () { if (!urls.length) throw new Error('no file urls returned'); return urls; };
        if (!line || !line.key) return done();
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function (r) {
          if (!r.ok) console.warn('RPDesignUpload: could not remove the carrier line (' + r.status + ')');
        }, function (e) { console.warn('RPDesignUpload: could not remove the carrier line', e); }).then(done);
      });
  }

  function bindDropzone(el) {
    if (!el || el._rpBound) return el;
    el._rpBound = true;
    el._files = [];
    var input = el.querySelector('input[type="file"]');
    var list = el.querySelector('[data-rp-file-list]');
    var err = el.querySelector('[data-rp-upload-error]');
    var max = parseInt(el.getAttribute('data-max'), 10) || MAX_FILES;
    function showErrors(errors) {
      if (!err) return;
      err.textContent = errors.join(' ');
      err.hidden = !errors.length;
    }
    function render() {
      if (!list) return;
      while (list.firstChild) list.removeChild(list.firstChild);
      el._files.forEach(function (f, i) {
        var li = document.createElement('li');
        var name = document.createElement('span');
        name.textContent = f.name;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rp-design__fileremove';
        btn.textContent = 'Remove';
        btn.setAttribute('aria-label', 'Remove ' + f.name);
        btn.addEventListener('click', function () {
          el._files.splice(i, 1);
          showErrors([]);
          render();
          changed();
        });
        li.appendChild(name);
        li.appendChild(btn);
        list.appendChild(li);
      });
    }
    function changed() {
      var ev;
      if (typeof CustomEvent === 'function') ev = new CustomEvent('rp-files-change', { bubbles: true });
      else { ev = document.createEvent('Event'); ev.initEvent('rp-files-change', true, false); }
      el.dispatchEvent(ev);
    }
    function add(fileList) {
      var r = mergeFiles(el._files, fileList, max);
      showErrors(r.errors);
      el._rejected = (el._rejected || []).concat(r.rejected);
      el._files = r.files;
      render();
      changed();
    }
    if (input) {
      input.addEventListener('change', function () { add(input.files); input.value = ''; });
    }
    ['dragenter', 'dragover'].forEach(function (t) {
      el.addEventListener(t, function (e) { e.preventDefault(); el.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      el.addEventListener(t, function (e) { e.preventDefault(); el.classList.remove('is-drag'); });
    });
    el.addEventListener('drop', function (e) { if (e.dataTransfer) add(e.dataTransfer.files); });
    el.hidden = false;
    return el;
  }

  /* Contact-form flow (variants A and C). ctx: { form, uploads: [box...], filesInput, noteInput, status, button, variantId, onUploaded }.
     Files upload the moment they are picked, and the submit button stays disabled until they are in: Shopify's bot check
     submits the form natively (it never waits for a submit listener), so anything left for submit time is lost.
     A failed upload never traps the customer: the form still sends, and the Upload line tells the store to ask for the files. */
  function groupsOf(ctx) {
    return (ctx.uploads || []).map(function (el) { return { prefix: el.getAttribute('data-prefix') || 'File', files: el._files || [] }; });
  }

  /* Labelled entries for every picked file that already has its CDN URL, in box order. */
  function entriesOf(ctx) {
    var out = [];
    groupsOf(ctx).forEach(function (g) {
      g.files.forEach(function (f, i) { if (f && f._rpUrl) out.push({ label: g.prefix + ' ' + (i + 1), url: f._rpUrl }); });
    });
    return out;
  }

  /* One line for the store's email, so an empty Files field always says why: nothing picked, rejected, or upload failed. */
  function noteFor(ctx) {
    var files = groupsOf(ctx).reduce(function (a, g) { return a.concat(g.files); }, []);
    var rejected = (ctx.uploads || []).reduce(function (a, el) { return a.concat(el._rejected || []); }, []);
    var up = files.filter(function (f) { return f && f._rpUrl; }).length;
    var failed = files.filter(function (f) { return f && f._rpFailed; }).length;
    var s = files.length ? files.length + ' selected, ' + up + ' uploaded' : 'no files selected';
    if (failed) s += ', ' + failed + ' FAILED TO UPLOAD (ask the customer for the files)';
    else if (files.length > up) s += ', ' + (files.length - up) + ' still uploading when sent';
    if (rejected.length) s += '; rejected: ' + rejected.join(', ');
    return s;
  }

  function makeCtx(ctx) {
    ctx.state = { busy: false, again: false };
    if (!ctx.noteInput && ctx.form && ctx.form.querySelector) ctx.noteInput = ctx.form.querySelector('input[name="contact[Upload]"]');
    function setBusy(b) {
      ctx.state.busy = b;
      if (ctx.button) { ctx.button.disabled = b; if (b) ctx.button.setAttribute('aria-busy', 'true'); else ctx.button.removeAttribute('aria-busy'); }
    }
    function write() {
      var entries = entriesOf(ctx);
      if (ctx.filesInput) ctx.filesInput.value = entries.map(lineFor).join('\n');
      if (ctx.noteInput) ctx.noteInput.value = noteFor(ctx);
      if (ctx.onUploaded) ctx.onUploaded(entries);
    }
    function sync() {
      if (ctx.state.busy) { ctx.state.again = true; return; }
      var pending = groupsOf(ctx).reduce(function (a, g) { return a.concat(g.files); }, [])
        .filter(function (f) { return f && !f._rpUrl && !f._rpFailed; });
      write();
      if (!pending.length || !ctx.variantId) { if (ctx.status && !pending.length) ctx.status.textContent = statusText(ctx); return; }
      setBusy(true);
      if (ctx.status) ctx.status.textContent = 'Uploading ' + pending.length + (pending.length === 1 ? ' file' : ' files') + '…';
      uploadViaCart(ctx.variantId, [{ prefix: 'File', files: pending }]).then(function (entries) {
        pending.forEach(function (f, i) { if (entries[i]) f._rpUrl = entries[i].url; else f._rpFailed = true; });
      }, function (err) {
        console.warn('RPDesignUpload: upload failed', err);
        pending.forEach(function (f) { f._rpFailed = true; });
      }).then(function () {
        setBusy(false);
        write();
        if (ctx.status) ctx.status.textContent = statusText(ctx);
        if (ctx.state.again) { ctx.state.again = false; sync(); }
      });
    }
    ctx.setBusy = setBusy;
    ctx.sync = sync;
    (ctx.uploads || []).forEach(function (u) { u.addEventListener('rp-files-change', sync); });
    write();
    if (typeof window !== 'undefined') {
      window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });
    }
    return ctx;
  }

  function statusText(ctx) {
    var files = groupsOf(ctx).reduce(function (a, g) { return a.concat(g.files); }, []);
    if (!files.length) return '';
    if (files.some(function (f) { return f && f._rpFailed; })) return FAIL_MSG;
    var n = files.length;
    return n + (n === 1 ? ' file' : ' files') + ' uploaded.';
  }

  /* Returns true while an upload is still running (the caller must stop the submit); the button is disabled then anyway. */
  function handleSubmit(ctx, e) {
    if (!ctx.state.busy) return false;
    e.preventDefault();
    return true;
  }

  function bindContactForm(form, variantId) {
    var ups = Array.prototype.slice.call(form.querySelectorAll('[data-rp-upload]'));
    if (!ups.length) return null;
    var wrap = form.querySelector('[data-rp-uploads]');
    var ctx = makeCtx({
      form: form, uploads: ups, filesInput: form.querySelector('input[name="contact[Files]"]'),
      status: form.querySelector('[data-rp-upload-status]'), button: form.querySelector('button[type="submit"]'),
      variantId: variantId || (wrap && wrap.getAttribute('data-variant'))
    });
    form.addEventListener('submit', function (e) { handleSubmit(ctx, e); });
    return ctx;
  }

  function autoInit(doc) {
    function run() {
      Array.prototype.forEach.call(doc.querySelectorAll('[data-rp-upload]'), bindDropzone);
      Array.prototype.forEach.call(doc.querySelectorAll('form[data-rp-upload-form]'), function (f) { bindContactForm(f); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run); else run();
  }

  return {
    MAX_FILES: MAX_FILES, MAX_BYTES: MAX_BYTES, EXTENSIONS: EXTENSIONS, FAIL_MSG: FAIL_MSG,
    checkFiles: checkFiles, mergeFiles: mergeFiles, noteFor: noteFor, entriesOf: entriesOf, urlsFromLine: urlsFromLine, lineFor: lineFor, groupsOf: groupsOf, appendFiles: appendFiles, uploadViaCart: uploadViaCart,
    bindDropzone: bindDropzone, bindContactForm: bindContactForm, makeCtx: makeCtx, handleSubmit: handleSubmit, autoInit: autoInit
  };
});
